<form [formGroup]="taxForm">
  <div class="form-row">
    <!-- tax name -->
    <div class="col-2 ellipsis-overflow">
      <small data-testid="tax-code">{{ tax.TaxCode }}</small>
    </div>

    <!-- tax fixed/additional-->
    <div class="col-4">
      <select
        id="column-2-row-{{ rowIndex }}"
        class="form-control text-start ps-2"
        formControlName="fixedAdditional"
        (change)="onFixedAdditionalChange($event)"
        (keyup)="onFixedAdditionalChangeKeyup($event)"
        (keydown)="onFixedAdditionalChangeKeydown($event)"
        *ngIf="!t.fixedAdditional.disabled"
        style="padding-top: 4.5px">
        <option value="None"><small>No Fixed/Addtl</small></option>
        <option value="Additional"><small>Additional Dollar</small></option>
        <option value="Fixed"><small>Fixed Dollar</small></option>
        <option value="Percent"><small>Fixed Percentage</small></option>
      </select>
    </div>

    <!-- tax rate amount -->
    <div class="col-3">
      <div class="input-group" *ngIf="!t.fixedAdditional.disabled">
        <input
          formControlName="rateAmount"
          class="form-control"
          appNumberInput
          (keyup)="onRateAmountChange($event)"
          id="column-3-row-{{ rowIndex }}"
          [attr.disabled]="t.rateAmount.disabled ? 'disabled' : null"
          data-testid="tax-rate" />
        <div
          *ngIf="t.fixedAdditional.value && t.fixedAdditional.value != 'Percent'"
          class="input-group-prepend">
          <span class="input-group-text">$</span>
        </div>
        <div *ngIf="t.fixedAdditional.value == 'Percent'" class="input-group-append">
          <span class="input-group-text">%</span>
        </div>
      </div>
    </div>

    <!-- tax total amount -->
    <div class="col-3">
      <div class="input-group">
        <input
          class="form-control"
          appNumberInput
          formControlName="total"
          [attr.disabled]="'disabled'"
          data-testid="tax-total" />
        <div class="input-group-prepend">
          <span class="input-group-text">$</span>
        </div>
      </div>
    </div>
  </div>
</form>
